
import { Component, Vue, Prop } from 'vue-property-decorator';

type ButtonType = 'primary' | 'secondary' | 'white' | 'white-error' | 'primary-inverted';

@Component<IconButton>({})
export default class IconButton extends Vue {
	@Prop({ type: String, required: false, default: 'primary' }) private type!: ButtonType;
	@Prop({ type: String, required: false, default: '' }) private id!: string;
	@Prop({ type: String, required: true, default: '' }) private icon!: string;
	@Prop({ type: String, required: false, default: '' }) private to!: string;
	@Prop({ type: String, required: false, default: '' }) private href!: string;
	@Prop({ type: String, required: false, default: '' }) private buttonClass!: string;
	@Prop({ type: String, required: false, default: '' }) private tooltip!: string;
	@Prop({ type: String, required: false, default: '' }) private target!: string;
	@Prop({ type: String, required: false, default: '' }) private prefix!: string;
	@Prop({ type: Boolean, required: false, default: false }) private loading!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private disabled!: boolean;


	/**
	 * Emit click event when it isn't disabled nor loading
	 *
	 * @param {MouseEvent} event
	 * @return {void}
	 */
	private click(event: MouseEvent): void {
		!this.loading && !this.disabled && this.$emit('click', event);
	}
}
